module.exports = "/cyber/_next/static/images/bg-78b7c130ef1b6e0d9bb4a3e9ebd7245e.jpg";